// 品质巡查点位图标路径配置
export const iconUrl = 'https://qn.base.file.gintell.cn/icon/patrol/'

// 高德地图key值配置
export const mapKey = 'f4a5948973eba202a0e894a3d7a845b6'

export const vjEnv = {
  // serviceUrl: 'https://vjmap.com/server/api/v1',
  serviceUrl: location.origin + '/server/api/v1',
  // workspace: 'test',
  workspace: 'prod',
  // 测试token
  // accessToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJRCI6MiwiVXNlcm5hbWUiOiJhZG1pbjEiLCJOaWNrTmFtZSI6ImFkbWluMSIsIkF1dGhvcml0eUlkIjoiYWRtaW4iLCJCdWZmZXJUaW1lIjo4NjQwMCwiZXhwIjo0ODEzMjE0NjY1LCJpc3MiOiJ2am1hcCIsIm5iZiI6MTY1OTYxMzY2NX0.h4AVDu_zLdOzw69UEBt4p0hE0HTQSiKNGLANJpcLbVw',
  // 生产token
  accessToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJRCI6MiwiVXNlcm5hbWUiOiJhZG1pbjEiLCJOaWNrTmFtZSI6ImFkbWluMSIsIkF1dGhvcml0eUlkIjoiYWRtaW4iLCJCdWZmZXJUaW1lIjo4NjQwMCwiZXhwIjo0ODcxNzgyODk5LCJpc3MiOiJ2am1hcCIsIm5iZiI6MTcxODE4MTg5OX0.A0E552EPEddKTysDzRdKrR_FMbLitdvCQUByep8Qd7k',
  mapId: 'c862741afc2e'
}
// 定时计划喷灌说明
export const timeIrrigationDesc = '喷灌时间段系统默认从5月1日至10月31日11:00至15:00不开启喷灌，如需调整，请联系系统管理员。'

// 智能计划喷灌说明
export const intellectIrrigationDesc = '喷灌根据所选的土壤传感器阈值和喷灌模型自动开启和关闭。喷灌时间段系统默认5月1日至10月31日11:00至15:00不开启喷灌，如需调整，请联系系统管理员。'

export default {
  apiUrl: ''
}
